/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LizardFSDisk,
    LizardFSDiskFromJSON,
    LizardFSDiskFromJSONTyped,
    LizardFSDiskToJSON,
    LizardFSNode,
    LizardFSNodeFromJSON,
    LizardFSNodeFromJSONTyped,
    LizardFSNodeToJSON,
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface VolumeLizardFSStatus
 */
export interface VolumeLizardFSStatus {
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof VolumeLizardFSStatus
     */
    master: StorageNodeMini | null;
    /**
     * 
     * @type {Array<LizardFSNode>}
     * @memberof VolumeLizardFSStatus
     */
    nodes: Array<LizardFSNode>;
    /**
     * 
     * @type {Array<LizardFSDisk>}
     * @memberof VolumeLizardFSStatus
     */
    disks: Array<LizardFSDisk>;
}

export function VolumeLizardFSStatusFromJSON(json: any): VolumeLizardFSStatus {
    return VolumeLizardFSStatusFromJSONTyped(json, false);
}

export function VolumeLizardFSStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeLizardFSStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'master': StorageNodeMiniFromJSON(json['master']),
        'nodes': ((json['nodes'] as Array<any>).map(LizardFSNodeFromJSON)),
        'disks': ((json['disks'] as Array<any>).map(LizardFSDiskFromJSON)),
    };
}

export function VolumeLizardFSStatusToJSON(value?: VolumeLizardFSStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'master': StorageNodeMiniToJSON(value.master),
        'nodes': ((value.nodes as Array<any>).map(LizardFSNodeToJSON)),
        'disks': ((value.disks as Array<any>).map(LizardFSDiskToJSON)),
    };
}


